import { render, staticRenderFns } from "./prexctransactions.vue?vue&type=template&id=3107bc54&"
import script from "./prexctransactions.vue?vue&type=script&lang=js&"
export * from "./prexctransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports